import I18n from 'i18n-js';
import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import {
  Button,
  Switch,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import CastIcon from '@material-ui/icons/Cast';
import CastConnectedIcon from '@material-ui/icons/CastConnected';

const StyledButton = withStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
  },
  label: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
    gap: '1rem',
    marginBottom: theme.spacing(2),
  },
}));

const hideVideoClassName = 'cast-hide-video';

const CastDialog = ({ castingManager, onEvent, onClose }) => {
  const [isStarting, setIsStarting] = useState(false);
  const [hideVideoElements, setHideVideoElements] = useState(
    document.body.classList.contains(hideVideoClassName)
  );
  const classes = useStyles();

  useEffect(() => {
    const onEvent = (event) => {
      const { type } = event;
      if (type === 'error' || type === 'connected') {
        setIsStarting(false);
      }
    };
    castingManager.onUpdate(onEvent);
    return () => {
      castingManager.offUpdate(onEvent);
    };
  }, [castingManager]);

  const startStopCasting = () => {
    if (castingManager.connected) {
      onEvent({ type: 'stop_casting' });
      onClose();
      return;
    }
    setIsStarting(true);
    castingManager.start({ muted: true, includeLocalAudio: false });
  };

  const toggleHideVideoElements = () => {
    const newHideVideoElements = !hideVideoElements;
    document.body.classList.toggle(hideVideoClassName, newHideVideoElements);
    setHideVideoElements(newHideVideoElements);
  };

  return (
    <>
      <DialogContentText>{I18n.t('dialog:casting:desc')}</DialogContentText>
      {castingManager.connected && (
        <>
          {/* <Typography variant="overline">Play audio on cast device</Typography>
          <div className={classes.row}>
            <Typography variant="body2">
              Send the meeting audio to the device you're casting to. Ideal for
              muting your computer and listening through external speakers.
            </Typography>
            <Switch
              checked={castAudio}
              onChange={toggleCastAudio}
              inputProps={{ 'aria-label': 'Play audio on cast device' }}
            />
          </div>
          <Typography variant="overline">Include local audio</Typography>
          <div className={classes.row}>
            <Typography variant="body2">
              Send the meeting audio to the device you're casting to. Ideal for
              muting your computer and listening through external speakers.
            </Typography>
            <Switch
              disabled={castMuted}
              checked={castIncludeLocalAudio}
              onChange={toggleIncludeLocalAudio}
              inputProps={{ 'aria-label': 'Include local audio' }}
            />
          </div> */}
          <Typography variant="overline">
            {I18n.t('dialog:casting:hide_video:title')}
          </Typography>
          <div className={classes.row}>
            <Typography variant="body2">
              {I18n.t('dialog:casting:hide_video:desc')}
            </Typography>
            <Switch
              checked={hideVideoElements}
              onChange={toggleHideVideoElements}
              inputProps={{
                'aria-label': I18n.t('dialog:casting:hide_video:title'),
              }}
            />
          </div>
        </>
      )}
      {castingManager.blocked && (
        <Typography variant="body2" component="p">
          {I18n.t('dialog:casting:blocked')}
        </Typography>
      )}
      <DialogActions>
        <StyledButton color="secondary" onClick={onClose}>
          {I18n.t('label:close')}
        </StyledButton>
        <StyledButton
          color="secondary"
          variant="contained"
          onClick={startStopCasting}
          disabled={castingManager.blocked || isStarting}
        >
          {castingManager.connected ? <CastConnectedIcon /> : <CastIcon />}
          {I18n.t('label:' + (castingManager.connected ? 'stop' : 'start'))}
          {isStarting && <CircularProgress color="inherit" size="1.2rem" />}
        </StyledButton>
      </DialogActions>
    </>
  );
};

export default CastDialog;
